import { Close as CloseIcon } from '@mui/icons-material'
import { IconButton, Snackbar, Divider } from '@mui/material'
import axios from 'axios'
import { t } from 'i18next'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import API_Routes from '../../../../constants/api-routes'
import { addFeedbackCustomerUrl, getCustomerDepartmentAttributeMap, secondary_theme_color } from '../../../../constants/constants'
import AutoCompleteMultiSelectDropdown from '../../basic-component/AutoCompleteMultiSelectDropdown'
import DatePickerComponent from '../../basic-component/DatePickerComponent'
import Dropdown from '../../basic-component/Dropdown'
import PageHeadContainer from '../../basic-component/PageHeadContainer'
import RichTextEditor from '../../basic-component/TextEditor/RichTextEditor'
import TextLabel from '../../basic-component/TextLabel'
import FileUpload from '../../basic-component/uploadFile'
import { uploadFeedbackAttachment } from '../../../../constants/constants'
import { apiHostUrl } from '../../../../constants/constants'
import { Form } from 'react-bootstrap'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import TextArea from '../../basic-component/TextArea'
import Textarea from '../../basic-component/AddFeedback/Component/Textarea'

const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 13px;
  box-sizing: border-box;
  margin-top: 2rem;

`
const FormRow = styled.div`

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
  box-sizing: border-box;
  align-items: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
`



const HorizontalContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`
export default function AddFeedback({ path }) {

  const [oldFeedbacks, setOldFeedbacks] = useState([])
  const [r, setR] = useState(0)
  const [oldFeedbackList, setOldFeedbackList] = useState([])
  const [feedbackType, setFeedbackType] = useState(0)
  const [addFeedbackResult, setAddFeedbackResult] = useState(null)
  const [open, setOpen] = useState(false);
  const [selectedType, setSelectedType] = useState(true);
  const [departmentAttributeMap, setDepartmentAttributeMap] = useState([])
  const [feedbackTypeList, setFeedbackTypeList] = useState([{ id: 103, desc: 'Feedback / General Query' }, { id: 100, desc: 'Complaint' }])
  const [attributeList, setAttributeList] = useState([])
  const [feedbackFile, setFeedbackFile] = useState('');
  const [filename, setFilename] = useState('');
  const [attributeMasterValueList, setAttributeMasterValueList] = useState([])
  const handleClientChange = (payload) => {
    setRequired((prev) => prev - 1 > 0 ? prev - 1 : 0)
    // console.log("From handle client change ", payload);

    // if (attributeList.some((attr) =>  (attr.departmentAttributeValId === payload.departmentAttributeValId))) return;
    if (attributeList.some((attr) => (attr.attributeId === payload.attributeId))) {
      setAttributeList((prev) => prev.filter((attr) => attr.attributeId !== payload.attributeId));
      setAttributeList(prev => ([...prev, payload]));
      return;
    };

    setAttributeList(prev => ([...prev, payload]));
  }
  const [dept, setDept] = useState("")
  const { csrfToken } = useSelector(state => state.csrf);
  const { userId: bidderId } = useSelector(state => state.role);
  const headers = {
    'Content-Type': 'application/json',
    'X-CSRF-TOKEN': csrfToken,
  };
  const newHeaders = headers
  newHeaders['X-Csrf-Token'] = csrfToken;
  newHeaders['Content-Type'] = 'application/json';

  const { roles, homeLink } = useSelector(state => state.role);
  // console.log(roles);

  const uploadFeedbackAttachemtURL = apiHostUrl + homeLink + uploadFeedbackAttachment;
  const formData = new FormData();
  formData.append('hiddenBidderId', bidderId);
  formData.append('_csrf', csrfToken);
  formData.append('_csrf', csrfToken);
  formData.append('fileName', '');
  formData.append('tagOldFeedback', '');

  const assignedDepartmentDesc = roles.filter(role => role.department.description != null).reduce((map, role) => {
    map.set(role.department.description, role.department.id);
    return map;
  }, new Map());
  const [assignedDepartment, ___] = useState([...assignedDepartmentDesc.entries()].map(([k, v]) => ({ desc: k, id: v })));
  // console.log(assignedDepartmentDesc);
  const processedList = useCallback((attributeMasterValueList) => {
    attributeMasterValueList = Object.values(attributeMasterValueList);
    if (!Array.isArray(attributeMasterValueList)) {
      return [];
    }
    setAttributeMasterValueList(attributeMasterValueList.map(item => ({
      departmentAttributeId: item.departmentAttributeId,
      desc: item.attributeVal,
      attributeType: "LIST", attributeId: "100", mandatory: "Y",
      attributeVal: item.departmentAttributeValId
    })));
    return true;
  }, [dept]);
  const [required, setRequired] = useState(assignedDepartment.length === 1 ? 2 : 3)
  const handleFileChange = (val) => {
    console.log(val);
    setFilename(val.toString());
  }
  const onclickFeedbackTypeHandler = useCallback((option) => {
    setFeedbackType(option.id);
    setRequired((prev) => prev - 1)
    if (assignedDepartment.length === 1) {
      onclickDepartmentHandler(assignedDepartment[0]);
    }


    // console.log(Array.from(assignedDepartmentDesc.keys()));
  }, [])

  const handleRadioClick = (id) => {
    setFeedbackType(id);
    console.log(id);
    if (id == 103) {
      setSelectedType(true);
    }
    else {
      setSelectedType(false);
    }
    setSelectedType(true);
    if (assignedDepartment.length === 1) {
      onclickDepartmentHandler(assignedDepartment[0]);
    }
  }
  const onclickDepartmentHandler = useCallback((deptObj) => {
    console.log(deptObj.id + " " + deptObj.desc);
    setDept(deptObj.id);
    fetchDepartmentAttributes(deptObj.id);
    fetchOldFeedbacks();
    setRequired((prev) => prev - 1)
  })
  const fetchOldFeedbacks = useCallback(() => {
    axios.post(API_Routes.getCustomerOldFeedbackList, { "bidderId": bidderId, "serviceId": dept }, { headers: newHeaders, withCredentials: true })
      .then(response => {
        if (response.data.length === 0) {
          return;
        }
        response.data.map((feedback) => {
          setOldFeedbackList((prev) => [...prev, { "label": feedback.feedbackCode, "desc": feedback.feedbackDesc }]);
        })

        // console.log(response.data);
      })
      .catch(error => {
        console.log(error);
      })
  })
  const url = apiHostUrl + homeLink + getCustomerDepartmentAttributeMap;
  const fetchDepartmentAttributes = (deptId) => {
    console.log(deptId);
    axios.post(url, { "serviceId": deptId }, { headers: newHeaders, withCredentials: true })
      .then(response => {
        console.log("Department Attribute Map ", response.data);
        setDepartmentAttributeMap(response.data);
        processedList(response.data['100'].attributeMasterValueList);
      })
      .catch(error => {
        console.log(error);
      })
  }
  const submitFeedbackHandler = () => {
    if (attributeList.length === 0 || required > 0 || sessionStorage.getItem("editorContent").length <= 0) {
      alert(t("general.label.mandatory.fields"));
      return;
    }
    const payload =
    {
      "feedbackDesc": sessionStorage.getItem("editorContent"),
      "feedbackFile": feedbackFile,
      "tagOldFeedback": JSON.stringify(oldFeedbacks),
      "feedbackTypeId": feedbackType,
      "serviceId": dept,
      "fileName": filename,
      "attributeList": attributeList
    }

    axios.post(addFeedbackCustomerUrl, payload, {
      withCredentials: true,
      headers: headers,
    })
      .then((data) => {
        console.log("hi");

        console.log(data.data);

        setAddFeedbackResult(data.data);
        setOpen(true);
        resetForm();
      })
      .catch((error) => {
        console.log(error);
      });
    // setOpen(true);
  }
  const oldFeedbackValueChange = (event, value) => {
    console.log(event, " ", value);
    setOldFeedbacks((prev) => { return { ...prev, value } });
  }
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    resetForm();
    setOpen(false);
  };
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  const resetForm = () => {

    console.log("Reset= ", r);
    setDept("");
    setFeedbackType(0);
    sessionStorage.setItem("editorContent", "");
    setR((prev) => prev + 1);
    setAttributeList([]);
    setFeedbackFile("");
    setFilename("");
    setOldFeedbacks([]);
    console.log("Reset= ", r);
  }
  useEffect(() => {
    console.log("----------------------------");
    console.log("Department ", dept);
    console.log("Feedback Type ", feedbackType);
    console.log("----------------------------");
    if (dept && feedbackType) {
      console.log("----------------------------");
      console.log("Attribute List ", attributeList);
      console.log("----------------------------");
    }
  }, [r])
  return (

    <Container fluid>
      <PageHeadContainer pageTitle={path[path.length - 1]} pathArray={path}></PageHeadContainer>
      <Row>
        <HorizontalContainer>
          {/* <div key={"feedbackType"} className="mb-3">
            <Form.Check // prettier-ignore
              type={feedbackTypeList[0].id}
              id={`Complain`}
              label={"Complain"}
              onClick={() => handleRadioClick(feedbackTypeList[0].id)}
              checked={selectedType == true}
            />

      
            <Form.Check
              type={feedbackTypeList[0].id}
              label={`General Query`}
              id={`General Query`}
              onClick={() => handleRadioClick(feedbackTypeList[1].id)}
              checked={selectedType == false}
            />
          </div> */}

       
        </HorizontalContainer>

        {assignedDepartment.length > 1 &&
          <FormRow>
            <TextLabel
              title={t('label.department.description')}
              isMandatory={true}
            ></TextLabel>
            <Dropdown isDisabled={false} title={"Choose"} items={assignedDepartment} onChange={onclickDepartmentHandler}></Dropdown>

          </FormRow>
        }

        {/* <FormRow>
            <TextLabel
              title={t('general.lable.select.feedbackType.text')}
              isMandatory={true}
            ></TextLabel>
            <Dropdown isDisabled={required > 2} isMandatory={true} title="Choose" items={feedbackTypeList} onChange={onclickFeedbackTypeHandler}></Dropdown>
          </FormRow> */}
        {/* </Col> */}

        <Col lg="12">
          {departmentAttributeMap &&
            Object.values(departmentAttributeMap).map((attribute, index) =>

              <FormRow key={index}>
                <TextLabel
                  title={attribute.attributeName}
                  isMandatory={true}
                ></TextLabel>
                {attribute.attributeType === "LIST" &&
                  <Dropdown isDisabled={required > 1} isMandatory={true} name="Client" onChange={handleClientChange} title={attribute.attributeName} items={attributeMasterValueList}></Dropdown>
                }
                {attribute.attributeType === "DATE" &&
                  <></>
                  // <DatePickerComponent isMandatory={true} width={'-webkit-fill-available'} onChangeAddFeedback={handleClientChange}></DatePickerComponent>
                }
              </FormRow>


            )
          }
        </Col>
        <Col lg="12">
          <Form.Group className="mb-3">
            <Form.Label className='fw-medium'>{t("feedbackDetails.feedbackDescription.text")}<span className='text-danger'>*</span> </Form.Label>

            {/* <Textarea></Textarea> */}
            <RichTextEditor reset={r}></RichTextEditor>
          </Form.Group>

          {/* <FormRow>
          <TextLabel
            title={t('feedbackDetails.feedbackDescription.text')}
            isMandatory={true}
          ></TextLabel>
          <RichTextEditor reset={r}></RichTextEditor>
        </FormRow> */}
        </Col>

        <Col lg="12">
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label className='fw-medium'>{t("general.button.uploadFile")}</Form.Label><span className='ms-2'>(.jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml)</span>
            <Form.Control type="file" bidderId={bidderId} data={formData} onChange={handleFileChange} fetchUrl={uploadFeedbackAttachemtURL} />
          </Form.Group>
          {/* <FormRow>
            <TextLabel
              title={t('general.button.uploadFile')}
              isMandatory={false}
              subLabel={" .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"}
            ></TextLabel>
            <FileUpload fileTypes={" .jpg, .jpeg, .gif, .png, .pdf, .doc, .docx, .xls, .xlsx, .ppt, .pptx, .zip, .rar, .xml, .xps, .msg, .eml"}
              bidderId={bidderId} data={formData} onChange={handleFileChange} fetchUrl={uploadFeedbackAttachemtURL}
            ></FileUpload>
          </FormRow> */}
        </Col>

        <Col lg="12">
          <Form.Group controlId="formFile" className="mb-3">
            <Form.Label className='fw-medium'>{t("general.label.similarFeedbackCode")}</Form.Label>
            <Form.Select aria-label="Default select example">
              <option>{t("general.label.option.menu")}</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </Form.Select>
          </Form.Group>

          {/* <FormRow>
            <TextLabel
              title={t('general.label.similarFeedbackCode')}
              isMandatory={false}
            ></TextLabel>
            <AutoCompleteMultiSelectDropdown values={oldFeedbackList} onValueChange={oldFeedbackValueChange}></AutoCompleteMultiSelectDropdown>
          </FormRow> */}
        </Col>
        <Col lg={12} className='text-end'>
          <Button variant="primary" onClick={() => submitFeedbackHandler()}>{t("menu.key.feedback.add")}</Button>
        </Col>

        {/* <Divider sx={{ width: '100%' }} /> */}
        {/* <Col lg="12" style={{ justifyContent: 'flex-end' }}>
          <Button className='btn-primary' style={{
            backgroundColor: 'green',
            color: 'white',
            borderRadius: '8px',
            fontFamily: 'Lato',
            fontWeight: '400',
            width: '10%'
          }}
            onClick={() => submitFeedbackHandler()}>ADD
          </Button>
        </Col> */}

        {open && <Snackbar
          open={open}
          autoHideDuration={100000}
          onClose={handleClose}
          message={t("general.label.feedback.code") + addFeedbackResult.feedbackCode + t("general.label.note.feedback.code")}
          action={action}
        />}

      </Row>
    </Container >
  )
}
